import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsClienteClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/cliente');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/cliente', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/cliente', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Cliente');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/cliente/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Cliente');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/cliente', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Cliente');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/cliente/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Cliente');
    }
  }

  async listarClienteInfoPedido(queries) {
    try {
      const representanteid = queries?.representanteid;
      let url = '/cliente/buscar/listarClienteInfoPedido';

      if (representanteid) {
        url = `/cliente/buscar/listarClienteInfoPedido/${representanteid}`;
      }

      const { data } = await this.api.get(url, { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async listarCliente(queries) {
    try {
      const { data } = await this.api.get('/cliente?page=1&perPage=4000&sortBy=clientenomefantasia&sortDesc=false', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Cliente');
    }
  }

  async getClienteByClientIdERP(clientIdERP) {
    try {
      const { data } = await this.api.get(`/cliente/buscar/getClienteByClientIdERP/${clientIdERP}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Cliente');
    }
  }

  async getInfoPedidoByClienteId(clienteId) {
    try {
      // Cache local simples (armazenado no cliente para evitar requisições duplicadas)
      if (!this._pedidoCache) {
        this._pedidoCache = {};
      }

      if (this._pedidoCache[clienteId]) {
        return this._pedidoCache[clienteId];
      }

      const response = await this.api.get(`/cliente/infoPedido/${clienteId}`);

      // Armazena no cache para evitar nova chamada com o mesmo clienteId
      this._pedidoCache[clienteId] = response.data;

      return response.data;
    } catch (error) {
      console.error('Erro ao obter infoPedido:', error);
      throw error;
    }
  }

  async listarClientePorRepresentante(representanteid, queries = {}) {
    try {
      const { data } = await this.api.get(`/cliente/buscar/listarCliente/${representanteid}`, { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar clientes do representante');
    }
  }

  async getInfoPedidoNovo(clienteIdERP) {
    try {
      if (!this._pedidoCacheNovo) {
        this._pedidoCacheNovo = {};
      }

      if (this._pedidoCacheNovo[clienteIdERP]) {
        return this._pedidoCacheNovo[clienteIdERP];
      }

      const response = await this.api.get(`/cliente/infoPedidoNovo/${clienteIdERP}`);

      this._pedidoCacheNovo[clienteIdERP] = response.data;

      return response.data;
    } catch (error) {
      console.error('Erro ao obter infoPedidoNovo:', error);
      throw error;
    }
  }
}
